/**
 * Converts a direction stat into a human-readable format
 * @param direction the angle, in degrees, clockwise from North
 * @param includeHalfWinds to optionally include half-wind compass directions (i.e. NNW, ESE)
 */
export function formatDirectionToCompassPoint(
    direction: number | null,
    { includeHalfWinds = false }: { includeHalfWinds?: boolean } = {},
) {
    if (direction == null || isNaN(direction)) return null;

    const degrees = direction % 360;
    const normalisedDegrees = degrees < 0 ? 360 + degrees : degrees;

    const compassPoints = !includeHalfWinds
        ? ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW']
        : [
              'N',
              'NNE',
              'NE',
              'ENE',
              'E',
              'ESE',
              'SE',
              'SSE',
              'S',
              'SSW',
              'SW',
              'WSW',
              'W',
              'WNW',
              'NW',
              'NNW',
          ];

    const index =
        Math.round((normalisedDegrees * compassPoints.length) / 360) % compassPoints.length;

    return compassPoints[index];
}
